import { render, staticRenderFns } from "./KaufschutzRateCreate.vue?vue&type=template&id=f75135e6&"
import script from "./KaufschutzRateCreate.vue?vue&type=script&lang=js&"
export * from "./KaufschutzRateCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports